import { connect } from "react-redux";
import {
  setSpreedlyErrors,
  setSpreedlyToken,
  triggerSpreedlyValidation,
  getSpreedlyToken,
  getSpreedlyErrors,
  getSpreedlyRunValidation,
} from "../../../data/spreedly";

import SpreedlyForm from "./SpreedlyForm";

const mapStateToProps = (state) => {
  return {
    token: getSpreedlyToken(state),
    validationErrors: getSpreedlyErrors(state),
    runValidation: getSpreedlyRunValidation(state),
  };
};

const mapActionCreators = {
  setSpreedlyErrors,
  setSpreedlyToken,
  triggerSpreedlyValidation,
};
export default connect(mapStateToProps, mapActionCreators)(SpreedlyForm);
